/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTaskBudgetCostsQuery } from '../../models/get-project-task-budget-costs-query';
import { GetProjectTaskBudgetCostsQueryResult } from '../../models/get-project-task-budget-costs-query-result';

export interface ApiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Params {
      body?: GetProjectTaskBudgetCostsQuery
}

export function apiTaskBudgetCostGetTaskBudgetCostsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostGetTaskBudgetCostsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostGetTaskBudgetCostsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTaskBudgetCostsQueryResult>;
    })
  );
}

apiTaskBudgetCostGetTaskBudgetCostsPost$Plain.PATH = '/api/TaskBudgetCost/GetTaskBudgetCosts';
